import React from 'react';
import { 
  Card, 
  CardContent, 
  Typography, 
  Box, 
  useTheme,
  alpha
} from '@mui/material';
import { 
  TrendingUp, 
  TrendingDown,
  AttachMoney,
  ShoppingCart,
  Receipt,
  Percent,
  Inventory,
  Add,
  People,
  Repeat
} from '@mui/icons-material';
import { DESIGN_SYSTEM } from '../../theme/designSystem';

const iconMap = {
  'currency-dollar': AttachMoney,
  'cart': ShoppingCart,
  'receipt': Receipt,
  'percent': Percent,
  'boxes': Inventory,
  'cart-plus': Add,
  'person-plus': People,
  'repeat': Repeat
};

/**
 * Componente de Métrica Unificado en Material-UI
 */
export default function MetricCardMUI({ 
  title, 
  value, 
  change, 
  icon, 
  color = '#4e73df',
  suffix = '',
  prefix = ''
}) {
  const theme = useTheme();
  const IconComponent = iconMap[icon] || AttachMoney;
  
  const formatValue = (val) => {
    if (typeof val === 'number') {
      if (val >= 1000000) {
        return `${(val / 1000000).toFixed(1)}M`;
      } else if (val >= 1000) {
        return `${(val / 1000).toFixed(0)}K`;
      }
      return val.toLocaleString();
    }
    return val;
  };

  const isPositiveChange = change > 0;
  const isNegativeChange = change < 0;

  return (
    <Card sx={{
      height: 120,
      background: `linear-gradient(135deg, ${alpha(color, 0.02)} 0%, ${alpha(theme.palette.background.paper, 1)} 100%)`,
      border: `1px solid ${alpha(color, 0.08)}`,
      borderRadius: 3,
      boxShadow: `0 4px 20px ${alpha(theme.palette.common.black, 0.06)}`,
      transition: 'all 0.3s ease',
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: `0 8px 30px ${alpha(theme.palette.common.black, 0.12)}`
      }
    }}>
      <CardContent sx={{ p: 2.5, height: '100%' }}>
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
          <Box 
            sx={{
              width: 40,
              height: 40,
              borderRadius: 2,
              backgroundColor: alpha(color, 0.1),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: color
            }}
          >
            <IconComponent fontSize="small" />
          </Box>
          
          {change !== null && change !== undefined && (
            <Box display="flex" alignItems="center" gap={0.5}>
              {isPositiveChange && <TrendingUp sx={{ fontSize: 16, color: theme.palette.success.main }} />}
              {isNegativeChange && <TrendingDown sx={{ fontSize: 16, color: theme.palette.error.main }} />}
              <Typography 
                variant="caption" 
                sx={{ 
                  color: isPositiveChange ? theme.palette.success.main : 
                         isNegativeChange ? theme.palette.error.main : 
                         theme.palette.text.secondary,
                  fontWeight: 600
                }}
              >
                {Math.abs(change).toFixed(1)}%
              </Typography>
            </Box>
          )}
        </Box>

        <Typography sx={DESIGN_SYSTEM.typography.metricLabel} color="text.secondary" gutterBottom>
          {title}
        </Typography>

        <Typography 
          sx={{
            ...DESIGN_SYSTEM.typography.metricNumber,
            color: color
          }}
        >
          {prefix}{formatValue(value)}{suffix}
        </Typography>
      </CardContent>
    </Card>
  );
}
